export enum PlanListInteractions {
  PageReady = 'page_ready',
  WidgetLoaded = 'widget_loaded',
  NavigateToList = 'navigate_to_list',
}
